import script from "./DailyTreatedOrdersChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyTreatedOrdersChart.vue?vue&type=script&setup=true&lang=js"

import "./DailyTreatedOrdersChart.vue?vue&type=style&index=0&id=4dad6cef&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dad6cef"]])

export default __exports__